import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from 'components/core/Button';
import { Image } from 'components/core/Image';
import check from 'assets/images/landing/homepage/check.svg';

export function IconDropdownOption({
	label,
	selected,
	value,
	onSelect,
	setLabel,
	setShowOptions,
}) {
	const clickHandler = () => {
		onSelect(value);
		setLabel(label);
		setShowOptions(false);
	};
	return (
		<Button
			className={classnames('dropdown-option', { selected })}
			onClick={clickHandler}
		>
			{label}
			{selected && (
				<Image
					src={check}
					className="check-icon"
				/>
			)}
		</Button>
	);
}

IconDropdownOption.propTypes = {
	selected: PropTypes.bool,
	onSelect: PropTypes.func.isRequired,
	setLabel: PropTypes.func.isRequired,
	setShowOptions: PropTypes.func.isRequired,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	label: PropTypes.string.isRequired,
};

export default IconDropdownOption;
